export enum OperationTypeEnum {
  CREATE = 1,
  UPDATE = 2,
  DELETE = 3,
  RESTORE = 4,
}